import styled, {css} from 'styled-components';


const SIZE = '280px';

const TeamsList = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  ${({fullWidth}) =>
    fullWidth
      ? css`
          width: 100%;
        `
      : css`
          max-width: ${SIZE};
          min-width: ${SIZE};
          width: ${SIZE};
        `}
`;

export default TeamsList;
